import { cn } from '@/lib/cn'

/**
 * Stämpeln som visar att en rabatt är förbrukad.
 *
 * Tidigare markerades det med sextio procents opacitet och en liten grön
 * bricka. Det räcker inte: i bläddringsläget fyller kortet hela skärmen, och
 * en lätt nedtoning läser som "laddar" snarare än som "slut". Eftersom en
 * förbrukad rabatt aldrig går att få tillbaka måste den vara omöjlig att
 * missa – och den ska se ut som stämpeln man fick vid inlösen, så att de två
 * hör ihop.
 */
export function UsedStamp({
  size = 'sm',
  className,
}: {
  size?: 'sm' | 'lg'
  className?: string
}) {
  return (
    <span
      className={cn(
        'pointer-events-none inline-flex shrink-0 items-center justify-center',
        'rotate-[-7deg] rounded-xl border-[3px] border-current text-stamp',
        'font-display font-extrabold tracking-[0.14em] uppercase',
        size === 'lg'
          ? 'rounded-2xl border-4 px-5 py-2 text-2xl'
          : 'px-2 py-0.5 text-[11px]',
        className,
      )}
    >
      Använd
    </span>
  )
}
